import { Component } from "@angular/core";
import { Whisky } from "../../data/whisky";
import { NavParams } from "ionic-angular/navigation/nav-params";
import { ViewController } from "ionic-angular/navigation/view-controller";
import { NewWhiskyPage } from "../newWhisky/newWhisky";
import { Events } from "ionic-angular/util/events";
import { ModalController } from "ionic-angular/components/modal/modal-controller";
import { WhiskyDB } from "../../data/db";
//import { DateTime } from "ionic-angular/components/datetime/datetime";

@Component({
  selector: "page-showWhisky",
  templateUrl: "showWhisky.html"
})
export class ShowWhiskyPage {
  whisky: Whisky;
  newWhiskyPage: any;
  image: string;
  imageTimeStamp: string;

  constructor(
    public viewCtrl: ViewController,
    private navParams: NavParams,
    private events: Events,
    private modalCtrl: ModalController
  ) {
    this.whisky = this.navParams.get("Whisky");
    this.image = null;
    WhiskyDB.db.loadImage(this.whisky);
    events.subscribe("image:loaded", (image: string, name: string, ts: number) => {
      if (this.whisky.name === name) 
      {
        this.image = image;
        this.imageTimeStamp = new Date(ts).toUTCString();
      }
    });

    console.log("image is " + this.image);

    console.log("whisky=" + this.whisky.name);
    this.newWhiskyPage = NewWhiskyPage;

    this.events.subscribe("whisky:saved", (event: any) => {
      console.log("whisky:saved: " + event.whisky);
      this.whisky = event.whisky;
      WhiskyDB.db.loadImage(this.whisky);
    });
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  editItem(e: any) {
    console.log("edit " + e);
    let modal = this.modalCtrl.create(this.newWhiskyPage, { whisky: e });
    modal.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/showWhisky/showWhisky.ts